<template>
    <div class="card mb-0" v-show="ratingOptions && sortedCompetencies && simulations">
        <el-table class="table-responsive table-flush"
                header-row-class-name="thead-light"
                :data="sortedCompetencies">

            <el-table-column width="200">
                <template v-slot="{row}">
                    <h4 class="mb-0">
                        {{ competencyName(row) }}
                    </h4>
                </template>
            </el-table-column>

            <el-table-column class-name="session" width="15">
                <template v-slot="{row}">
                    <rating :options="ratingOptions"></rating>
                </template>
            </el-table-column>

            <el-table-column v-for="(simulation, index) in realSimulations" :key="index"
                align="center" header-align="center"
                class-name="session" width="50"
            >
                <span slot="header">
                    {{ simulation.name }}
                </span>

                <template v-slot="{row}">
                    <rating v-if="simulation.state.published && simulation.state.competencies && simulation.state.competencies[simulationRole]"
                        :name="competencyName(row)"
                        :description="competencyDescription(row)"
                        :value="simulation.state.competencies[simulationRole][row.id]"
                        :options="ratingOptions"
                    >
                    </rating>
                    <rating v-else :options="ratingOptions"></rating>
                </template>

            </el-table-column>
            
            <el-table-column class-name="session" width="15">
                <template v-slot="{row}">
                    <rating :options="ratingOptions"></rating>
                </template>
            </el-table-column>

            <el-table-column label="">
            </el-table-column>
            
        </el-table>
    </div>
</template>

<script>
    import Rating from './Rating'

    export default {

        components: {
            Rating
        },

        props: {

            domain: {
                type: Object,
                required: true
            },

            num: {
                type: Number,
            },

            simulations: {
                type: Array,
            },

            competencies: {
                type: Object,
            },

            position1Competencies: {
                type: Object,
            },

            position2Competencies: {
                type: Object,
            },

            registration: {
                type: Object,
            },

            ratingOptions: {
                type: Array,
            },
        },

        computed: {

            realSimulations() {
                return this.simulations.filter(sim => !sim.assessment)
            },

            simulationRole() {
                return this.registration.degree['simulation_role_' + this.num]
            },

            sortedCompetencies() {
                return Object.values(this['position' + this.num + 'Competencies'])
                    .map(competency => this.competencies[competency.id])
                    .filter(competency => competency.domain.id == this.domain.id)
                    .sort((a, b) => a.position - b.position)
            },
        },

        methods: {

            competencyName(competency) {
                const nameProp = 'name_' + this.registration.degree.lang
                return competency[nameProp]
            },

            competencyDescription(competency) {
                const posCompetency = this['position' + this.num + 'Competencies'][competency.id]
                if (!posCompetency) {
                    return ''
                }
                return posCompetency.pivot.description
            }
        }
    }
</script>

<style scoped>

    .card {
        box-shadow: 0 0 2rem 0 rgba(136,152,170,.3);
        margin-top: 1rem;
    }
    .card >>> .el-table__body-wrapper {
        padding-bottom: 5px;
    }
    .card >>> .el-table th.session .cell {
        justify-content: center;
        line-height: 1rem;
        padding: 0.7rem 0;
    }
    .card >>> .el-table th.session .cell a:hover {
        color: #233dd2;
    }
    .card >>> .el-table .session {
        padding-left: 0;
        padding-right: 0;
        max-width: 70px;
    }
    
</style>
